import Sent from "src/img/emailCampaigns/sent.svg";
import Scheduled from "src/img/emailCampaigns/scheduled.svg";
import Draft from "src/img/emailCampaigns/draft.svg";
import CustomAudience from "src/img/emailCampaigns/audience.svg";
import Settings from "src/img/emailCampaigns/settings.svg";
import { USER_GROUP } from "src/constants/perks";
import { customNames } from "src/utils/helpers";
import pluralize from "pluralize";

export const getEmailAudienceDisplayName = audienceName => {
    if (audienceName === USER_GROUP.CLIENTS) {
        return customNames.clients;
    }
    if (audienceName === USER_GROUP.EMPLOYEES) {
        return customNames.employees;
    }
    return audienceName;
};

export const getEmailAudienceUsersDisplayName = audienceName => {
    if (![USER_GROUP.EMPLOYEES, USER_GROUP.CLIENTS].includes(audienceName)) {
        return audienceName;
    }
    return `${pluralize.singular(getEmailAudienceDisplayName(audienceName))} Users`;
};

export const SIDEBAR_DATA = [
    {
        id: "sent",
        icon: Sent,
        title: "Sent Campaigns",
    },
    {
        id: "scheduled",
        icon: Scheduled,
        title: "Scheduled",
    },
    {
        id: "draft",
        icon: Draft,
        title: "Draft",
    },
    // TODO: Re-enable when needed
    // {
    //     id: "saved",
    //     icon: Saved,
    //     title: "Saved",
    // },
    // {
    //     id: "completed",
    //     icon: Completed,
    //     title: "Completed",
    // },
    {
        id: "custom_audience",
        icon: CustomAudience,
        title: "Custom Audience",
    },
    {
        id: "settings",
        icon: Settings,
        title: "Settings",
    },
];

export const SIDEBAR_LIST = {
    SENT: "sent",
    SCHEDULED: "scheduled",
    DRAFT: "draft",
    SAVED: "saved",
    COMPLETED: "completed",
    CUSTOM_AUDIENCE: "custom_audience",
    SETTINGS: "settings",
};

export const NOTIFICATION_EMAIL_TYPE = {
    SCHEDULE: "schedule",
    SEND_NOW: "send_now",
};

export const PREVIEW_TYPE = {
    DESKTOP: "desktop",
    MOBILE: "mobile",
};

export const SOCIAL_MEDIAS = {
    FACEBOOK: "facebook",
    INSTAGRAM: "instagram",
    X: "x",
    LINKEDIN: "linkedin",
    YOUTUBE: "youTube",
    WEB: "web",
};

export const AUDIENCE_ACTIONS_LIST = [
    {
        label: "Manage Audience",
        value: "manage_audience",
    },
    {
        label: "View Contacts",
        value: "view_contacts"
    },
    {
        label: "Edit Audience Name",
        value: "edit_audience_name"
    },
    {
        label: "Delete",
        value: "delete_audience"
    }
];

export const AUDIENCE_ACTIONS = {
    MANAGE_AUDIENCE: "manage_audience",
    VIEW_CONTACTS: "view_contacts",
    EDIT_AUDIENCE_NAME: "edit_audience_name",
    DELETE_AUDIENCE: "delete_audience",
};

export const MOBILE_COUNTRY_CODES = [
    { code: "+1", flag: "🇺🇸", label: "USA" },
    { code: "+44", flag: "🇬🇧", label: "UK" },
    { code: "+63", flag: "🇵🇭", label: "Philippines" },
    { code: "+91", flag: "🇮🇳", label: "India" },
    { code: "+81", flag: "🇯🇵", label: "Japan" },
    { code: "+61", flag: "🇦🇺", label: "Australia" },
    { code: "+64", flag: "🇳🇿", label: "New Zealand" },
    { code: "+675", flag: "🇵🇬", label: "Papua New Guinea" },
    { code: "+679", flag: "🇫🇯", label: "Fiji" },
    { code: "+677", flag: "🇸🇧", label: "Solomon Islands" },
    { code: "+678", flag: "🇻🇺", label: "Vanuatu" },
    { code: "+62", flag: "🇮🇩", label: "Indonesia" }
];

export const CONTACT_ADDING_TYPE = {
    CSV: "csv",
    MANUALLY_ADDED: "manually_added",
};

export const SEND_TYPE = {
    SCHEDULE: "schedule",
    SEND_NOW: "send_now"
};

export const EMAIL_STATUS = {
    DRAFT: "draft",
    SCHEDULED: "scheduled",
    SENT: "sent",
    FAILED: "failed",
    QUEUED: "queued",
    SENDING: "sending"
};

export const DRAFT_SCHEDULED_ACTIONS = {
    UPDATE: "Update",
    DUPLICATE: "Duplicate",
    DELETE: "Delete",
};

export const DOWNGRADE_STEPS = {
    SELECT: "select",
    CONFIRM: "confirm",
};

export const DOWNGRADE_STATUS = {
    DOWNGRADE: "downgrade",
    CANCEL: "cancel",
};
